import { Stack, Typography } from "@mui/material";
import AppRightSidebar from "../components/AppRightSidebar";
import NetworkSection from "../components/Network/NetworkSection";

function Network() {
  return (
    <Stack
      id="network-container"
      direction="row"
      spacing={1.5}
      sx={{ justifyContent: "space-between" }}
    >
      <NetworkSection />
      <AppRightSidebar />
    </Stack>
  );
}

export default Network;
